import { map, debounce } from 'lodash';
import { getHighlightKeywordsApi, setHighlightKeywordsApi } from '../../apis/core_basic_api/highlight';
import {
    enable,
    pubWithoutDebounce,
    highlightChannel,
    createStyles
} from '@patsnap-utils/highlight';

const _publish_ = (data) => {
    const config = data.map(({ value: keyword, color }) => ({ keyword, color }));
    pubWithoutDebounce(config);
};

export default (namespace, origin) => ({
    data() {
        return {
            syncHighlightConfigToServerMixin_initialKeywords: []
        };
    },
    created() {
        this.highlightChannel = highlightChannel({
            namespace,
            origin,
        });

        this.un = this.highlightChannel.on((data, statusChanged/*, event */) => {
            const configForPtHighlightPanel = statusChanged ? data.getArrayFormat(statusChanged.enable) : data.getArrayFormat();
            // 订阅配置变化，并作出反应
            /* step 1: 更新 UI */
            this.syncHighlightConfigToServerMixin_initialKeywords = configForPtHighlightPanel;
            /* step 2: 执行高亮 */
            _publish_(configForPtHighlightPanel);
            // 该方法会读取 localstorage, 决定是刷新样式还是删除样式
            createStyles(namespace)();
        });
    },
    mounted() {
        this.syncHighlightConfigToServerMixin_pull();
    },
    destroyed() {
        if (this.un) {
            this.un();
        }
    },
    methods: {
        syncHighlightConfigToServerMixin_push: debounce(function(model, disabled) {
            model = map(model, item => {
                return {
                    color: item.color,
                    value: item.value
                };
            });
            /* step 1: 更新 localstorage */
            this.highlightChannel.emit(model);

            /* step 2: 向服务器推送 keywords */
            setHighlightKeywordsApi({ keywords: model });

            const config = model.map((item) => {
                return { color: item.color, keyword: item.value };
            });
            /* step 3: 执行高亮 */
            pubWithoutDebounce(config);
            setTimeout(() => {
                enable(namespace)(!disabled);
            }, 100);
        }, 500),
        async syncHighlightConfigToServerMixin_pull() {
            /* step 1: 从服务器获取 keywords */
            // eslint-disable-next-line camelcase
            let response = {};
            try {
                response = await getHighlightKeywordsApi();
            } catch (e) {
                // pass
            }
            const data = response.map(item => {
                return {
                    color: item.color,
                    value: item.value
                };
            });

            /* step 2: 更新 localstorage */
            this.highlightChannel.emit(data);
            let configForPtHighlightPanel = data;
            const enabled = enable(namespace)();
            let disabled;
            if (enabled === undefined) {
                disabled = false;
            } else {
                disabled = !enabled;
            }
            configForPtHighlightPanel = map(configForPtHighlightPanel, item => {
                item.disabled = disabled;
                return item;
            });
            /* step 3: 更新 UI */
            this.syncHighlightConfigToServerMixin_initialKeywords = configForPtHighlightPanel;
            /* step 4: 执行高亮 */
            _publish_(configForPtHighlightPanel);
            return configForPtHighlightPanel;
        },
    },
});
